import { Box, Typography, Button, FormControl, OutlinedInput } from "@mui/material";
import React, { useState, useEffect } from "react";
import http from "../../utils/http-common";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import tick from "../../assets/landing_page/new/teenyicons_tick-circle-solid.svg";
import { ProfileTab } from "../../Layouts/Drawer/Topbar";
export const Profile = () => {
  const [userData, setUserData] = useState({});
  const [image, setImage] = useState("");
  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [skillSet, setSkillSet] = useState("");
  const [imageChanged, setImageChanged] = useState(false);
  const user_id = localStorage.getItem("user_id");

  const fetchUserData = async () => {
    try {
      const response = await http.get(`/auth_service/user/view/${user_id}`);
      if (response.status === 200) {
        const data = response.data;
        localStorage.setItem("user_picture", data.uploaded_picture_path || "");
        setUserData(data);
        setImage(data.uploaded_picture_path || "");
        setUserName(data.user_name || "");
        setEmail(data.email || "");
        setPhoneNumber(data.phone_number || "");
        setSkillSet(data.skill_set || "");
        <ProfileTab />
      }
    } catch (error) {
      console.error("Error fetching user data", error);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const handleFileChange = (event) => {
    setImageChanged(true);
    const file = event.target.files[0];
    const validTypes = ["image/jpeg", "image/png", "image/gif"];
    const maxSize = 5 * 1024 * 1024; // 5 MB

    if (file && validTypes.includes(file.type) && file.size <= maxSize) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result); // Preview the image
      };
      reader.readAsDataURL(file);
      //   uploadImage(file);
    } else {
      alert("Please upload a valid image file (JPEG, PNG, GIF) under 5MB.");
    }
  };

  const handleRemovePicture = () => {
    setImage("");
  };
  function base64ToBlob(base64, mime) {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: mime });
  }
  function extractBase64Data(base64String) {
    const base64Data = base64String.split(",")[1];
    return base64Data;
  }
  const validatePhoneNumber = (number) => {
    const phoneRegex = /^[+]?[0-9]{10,15}$/; // Adjust regex based on your phone number format
    return phoneRegex.test(number);
  };
  const handleSave = async () => {
    if (phoneNumber && !validatePhoneNumber(phoneNumber)) {
      toast.error("Invalid phone number.");
      return;
    }

    const formData = new FormData();
    formData.append("phone_number", phoneNumber);
    formData.append("skill_set", skillSet);

    if (imageChanged) {
      const base64Image = extractBase64Data(image);
      const mime = "image/jpeg";
      const blob = base64ToBlob(base64Image, mime);
      const file = new File([blob], "filename.jpeg", { type: mime });
      formData.append("uploaded_picture_path", file);
    } else {
      formData.append("uploaded_picture_path", image);
    }
    try {
      const response = await http.put(
        `/auth_service/user/update/${user_id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success) {
        toast.success(
          <>
            <div
              style={{
                fontFamily: "Inter, sans-serif",
                fontSize: "14px",
                fontWeight: "600",
                lineHeight: "24px",
                textAlign: "left",
                marginBottom: "8px",
                marginTop: "10px",
              }}>
              User Updated Successfully
            </div>
          </>,
          {
            icon: (
              <img
                src={tick}
                alt='Success Icon'
                style={{ width: "20px", height: "20px", color: "#0057D5" }}
              />
            ),
          }
        );
        const newUserPicture = response.data.updatedUser?.uploaded_picture_path;
        localStorage.setItem("user_picture", newUserPicture);
        const event = new Event("userPictureUpdated");
        window.dispatchEvent(event);
        window.location.reload();
        fetchUserData();
      }
    } catch (error) {
      console.error("Error updating user data", error);
      toast.error("Failed to update user");
    }
  };
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.clear();

    navigate("/");
    window.location.reload();
  };
  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}>
      <Box
        sx={{
          height: "80%",
          width: "90%",
          border: "1px solid #E7E8EA",
          display: "flex",
          flexDirection: "column",
          background: "#FFFFFF",
          borderRadius: "12px",
          p: 5,
        }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}>
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "600",
              color: "#000000",
            }}>
            Profile
          </Typography>
        </Box>

        <Box
          sx={{
            border: "1px solid #E7E8EA",
            height: "40px",
            width: "100%",
            background: "#F8F8F8",
            borderRadius: "8px",
            mt: 2,
          }}>
          <Box sx={{ display: "flex", p: 1 }}>
            <svg
              width='20'
              height='20'
              viewBox='0 0 20 20'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 15C9.45 15 9 14.55 9 14V10C9 9.45 9.45 9 10 9C10.55 9 11 9.45 11 10V14C11 14.55 10.55 15 10 15ZM11 7H9V5H11V7Z'
                fill='#474747'
              />
            </svg>
            <Typography
              sx={{
                marginLeft: 2,
                fontWeight: "600",
                fontSize: "14px",
                color: "#474747",
              }}>
              Changes to your profile will apply to all your workspaces.
            </Typography>
          </Box>
        </Box>
        <Box
          style={{ display: "flex", alignItems: "center", marginTop: "10px" }}>
          <Box
            style={{
              width: "90px",
              height: "90px",
              borderRadius: "50%",
              border: "1px solid #ccc",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
              marginTop: "20px",
              backgroundColor: !image ? "#FF2800" : "white",
            }}>
            {image ? (
              <img
                src={image}
                alt='Profile'
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            ) : (
              <Typography
                sx={{
                  color: "white",
                  fontSize: "36px",
                  fontWeight: "500",
                  textTransform: "uppercase",
                  fontFamily: "Inter, sans-serif",
                }}>
                {userName?.charAt(0) || ""}
              </Typography>
            )}
          </Box>

          <Box
            style={{
              display: "flex",
              flexDirection: "column",
              marginLeft: "58px",
            }}>
            <Button
              variant='contained'
              onClick={() => document.getElementById("file-input").click()}
              sx={{
                fontFamily: "Inter, sans-serif",
                textTransform: "none",
                fontWeight: 500,
                backgroundColor: "#FF2800",
                padding: "6px 16px",
                "&:hover": {
                  backgroundColor: "#FF2800",
                },
                marginTop: "10px",
              }}>
              Upload Picture
            </Button>
            <input
              type='file'
              id='file-input'
              style={{ display: "none" }}
              accept='image/*'
              onChange={handleFileChange}
            />
            <Button
              variant='contained'
              onClick={handleRemovePicture}
              sx={{
                fontFamily: "Inter, sans-serif",
                textTransform: "none",
                fontWeight: 500,
                backgroundColor: "#FAFAFA",
                "&:hover": {
                  backgroundColor: "#FAFAFA",
                },
                padding: "6px 16px",
                color: "black",
                border: "1px solid black",
                marginTop: "12px",
              }}>
              Remove Picture
            </Button>
          </Box>
        </Box>
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "10px",
            marginLeft: "2px",
          }}>
          <Typography
            variant='body2'
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: "14px",
              fontWeight: 500,
              lineHeight: "20px",
              textAlign: "left",
              marginTop: "30px",
            }}>
            User Name
          </Typography>
          <Box style={{ marginLeft: "73px", flexGrow: 1 }}>
            <FormControl
              sx={{ height: "32px", width: "100%", marginTop: "30px" }}>
              <OutlinedInput
                placeholder='Enter User Name'
                value={userName} // Bind state
                disabled
                onChange={(e) => setUserName(e.target.value)}
                sx={{
                  height: "100%",
                  backgroundColor: "#D3D3D3",
                  "& .MuiOutlinedInput-input": {
                    // Styles for the input field
                  },
                  "& .MuiInputBase-input::placeholder": {
                    fontFamily: "Inter, sans-serif",
                    fontSize: "12px",
                    fontWeight: 500,
                    lineHeight: "20px",
                    textAlign: "left",
                  },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "gray", // Default border color
                    },
                    "&:hover fieldset": {
                      borderColor: "gray", // Border color on hover
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "gray", // Border color on focus
                    },
                  },
                }}
              />
            </FormControl>
          </Box>
        </Box>
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "10px",
            marginLeft: "2px",
          }}>
          <Typography
            variant='body2'
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: "14px",
              fontWeight: 500,
              lineHeight: "20px",
              textAlign: "left",
              marginTop: "10px",
            }}>
            Email ID{" "}
          </Typography>
          <Box style={{ marginLeft: "95px", flexGrow: 1 }}>
            <FormControl
              sx={{ height: "32px", width: "100%", marginTop: "10px" }}>
              <OutlinedInput
                placeholder='Enter Email ID'
                value={email} // Bind state
                disabled // Make it uneditable
                onChange={(e) => setEmail(e.target.value)}
                sx={{
                  height: "100%",
                  backgroundColor: "#D3D3D3",
                  "& .MuiOutlinedInput-input": {
                    // Styles for the input field
                  },
                  "& .MuiInputBase-input::placeholder": {
                    fontFamily: "Inter, sans-serif",
                    fontSize: "12px",
                    fontWeight: 500,
                    lineHeight: "20px",
                    textAlign: "left",
                  },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "gray", // Default border color
                    },
                    "&:hover fieldset": {
                      borderColor: "gray", // Border color on hover
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "gray", // Border color on focus
                    },
                  },
                }}
              />
            </FormControl>
          </Box>
        </Box>
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "10px",
            marginLeft: "2px",
          }}>
          <Typography
            variant='body2'
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: "14px",
              fontWeight: 500,
              lineHeight: "20px",
              textAlign: "left",
              marginTop: "10px",
            }}>
            Phone Number
          </Typography>
          <Box style={{ marginLeft: "49px", flexGrow: 1 }}>
            <FormControl
              sx={{ height: "32px", width: "100%", marginTop: "10px" }}>
              <OutlinedInput
                placeholder='Enter Phone Number'
                value={phoneNumber} // Bind state
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow only numbers
                  const numericValue = value.replace(/[^0-9]/g, "");
                  setPhoneNumber(numericValue); // Update state with numeric value only
                }} // Update state on change
                sx={{
                  height: "100%",
                  backgroundColor: "white",
                  "& .MuiOutlinedInput-input": {
                    // Styles for the input field
                  },
                  "& .MuiInputBase-input::placeholder": {
                    fontFamily: "Inter, sans-serif",
                    fontSize: "12px",
                    fontWeight: 500,
                    lineHeight: "20px",
                    textAlign: "left",
                  },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "gray", // Default border color
                    },
                    "&:hover fieldset": {
                      borderColor: "gray", // Border color on hover
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "gray", // Border color on focus
                    },
                  },
                }}
              />
            </FormControl>
          </Box>
        </Box>
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "10px",
            marginLeft: "2px",
          }}>
          <Typography
            variant='body2'
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: "14px",
              fontWeight: 500,
              lineHeight: "20px",
              textAlign: "left",
              marginTop: "10px",
            }}>
            Skill Set{" "}
          </Typography>
          <Box style={{ marginLeft: "95px", flexGrow: 1 }}>
            <FormControl
              sx={{ height: "32px", width: "100%", marginTop: "10px" }}>
              <OutlinedInput
                placeholder='Enter Skill Set of the user'
                value={skillSet} // Bind state
                onChange={(e) => setSkillSet(e.target.value)} // Update state on change
                sx={{
                  height: "100%",
                  backgroundColor: "white",
                  "& .MuiOutlinedInput-input": {
                    // Styles for the input field
                  },
                  "& .MuiInputBase-input::placeholder": {
                    fontFamily: "Inter, sans-serif",
                    fontSize: "12px",
                    fontWeight: 500,
                    lineHeight: "20px",
                    textAlign: "left",
                  },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "gray", // Default border color
                    },
                    "&:hover fieldset": {
                      borderColor: "gray", // Border color on hover
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "gray", // Border color on focus
                    },
                  },
                }}
              />
            </FormControl>
          </Box>
        </Box>
        <Button
          variant='contained'
          onClick={handleSave}
          sx={{
            fontFamily: "Inter, sans-serif",
            width: "90px",
            textTransform: "none",
            fontWeight: 500,
            backgroundColor: "#FF2800",
            padding: "6px 16px",
            "&:hover": {
              backgroundColor: "#FF2800",
            },
            marginTop: "50px",
            marginLeft: "auto",
          }}>
          Save
        </Button>
      </Box>
    </Box>
  );
};
